export default __webpack_public_path__ + "static/media/more.a7913902.svg";